window.addEventListener('DOMContentLoaded', function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  const container = document.querySelector('.stacking-cards');
  const header = document.querySelector('#header');
  const headerOffset = header ? -header.offsetHeight : 0;

  let cards = gsap.utils.toArray('.stack-card');
  const cardsLength = cards.length;

  // create a single ST tied to the container so all cards unpin when the container ends
  const containerEnd = ScrollTrigger.create({
    trigger: container,
    start: () => `top+=${headerOffset} top`, // pin as the card hits the top (accounting for fixed header)
    end: 'bottom bottom',
    pin: false,
    pinSpacing: false,
  });

  cards.forEach((card, index) => {
    let scaleDown = 0;
    let topScale = 0;
    let transformScale = 0; //(index + 1) * 25;
    // scale animation
    topScale = headerOffset - (index + 1) * 30;
    // console.log("index" + index + ": " + topScale);
    if (index < cardsLength - 1) {
      scaleDown = gsap.to(card, {
        scale: 1 - (cardsLength - index - 1) / 30,
        transform: 'translateY(' + transformScale + 'px)',
        ease: 'in-out',
        paused: true,
      });
    }

    // cards scrolltrigger
    ScrollTrigger.create({
      trigger: card,
      start: () => `top+=${topScale} top`, // pin as the card hits the top (accounting for fixed header)
      endTrigger: container, // stop pinning when the container ends
      end: `bottom bottom`, //ends when container bottom reaches viewport bottom
      pin: true, // pins the card
      pinSpacing: false, // cards stack without pushing content
      anticipatePin: 1, // smoother handoff as pins stack
      scrub: !!scaleDown, // ties the scale to scroll
      animation: scaleDown, // keep scale effect scaling
      // markers: true, // debug
      toggleActions: 'restart none none reverse',
    });
  });
});
